import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cb55a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-py-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "คืน/แลกเปลี่ยนสินค้า")
], -1))
const _hoisted_3 = { class: "return-form p-mx-3" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = { class: "p-mb-3" }
const _hoisted_6 = { class: "p-mb-3" }
const _hoisted_7 = { class: "p-mb-3" }
const _hoisted_8 = { class: "p-pt-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-pt-5 p-text-center" }, [
  /*#__PURE__*/_createElementVNode("u", { class: "pointer f-size-14" }, "เงื่อนไขการคืน/เปลี่ยนสินค้า")
], -1))
const _hoisted_10 = { class: "p-pt-4" }
const _hoisted_11 = { class: "p-pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TabView, { class: "return-tab" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: "ทำรายการใหม่",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_InputSelect, {
                  title: "รายการ",
                  text: "รายการ",
                  name: "returnTypeId",
                  valueField: "id",
                  textField: "name",
                  options: _ctx.returnType,
                  onOnDataChange: _ctx.onReturnTypeChange,
                  "model-value": _ctx.form.returnType,
                  isRequired: "",
                  ref: "returnTypeId"
                }, null, 8, ["options", "onOnDataChange", "model-value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputSelect, {
                  title: "ช่องทางการสั่งซื้อ",
                  text: "ช่องทางการสั่งซื้อ",
                  name: "saleChanelId",
                  valueField: "id",
                  textField: "name",
                  placeholder: "กรุณาเลือก",
                  options: _ctx.saleChannel,
                  onOnDataChange: _ctx.onSaleChanelChange,
                  "model-value": _ctx.form.saleChannel,
                  isRequired: "",
                  ref: "saleChanelId"
                }, null, 8, ["options", "onOnDataChange", "model-value"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.invoiceNo,
                  textFloat: "หมายเลขคำสั่งซื้อ / เลขที่ใบเสร็จ",
                  placeholder: "FAXXXXXXX",
                  type: "text",
                  name: "telephone",
                  maxlength: 10,
                  isRequired: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.form.invoiceNo = $event)),
                  class: "f-regular"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.name,
                  textFloat: "ชื่อ-นามสกุล",
                  placeholder: "ชื่อ-นามสกุล",
                  type: "text",
                  name: "telephone",
                  maxlength: 10,
                  isRequired: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                  class: "f-regular"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  label: "ดำเนินการต่อ",
                  class: "w-100",
                  onClick: _ctx.onSubmitReturnForm
                }, null, 8, ["onClick"])
              ]),
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, {
            header: "ติดตามสถานะ",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.invoiceNo,
                  textFloat: "หมายเลขคำสั่งซื้อ / เลขที่ใบเสร็จ",
                  placeholder: "FAXXXXXXX",
                  type: "text",
                  name: "telephone",
                  maxlength: 10,
                  isRequired: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.invoiceNo = $event)),
                  class: "f-regular"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  label: "ค้นหา",
                  class: "w-100"
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}